const generateCaption = (tokens) => ({
    fontFamily: tokens.aliasesFontFamilyDefault,
    fontSize: tokens.aliasesFontSizeCaption,
    lineHeight: tokens.aliasesLineHeightCaption,
    letterSpacing: tokens.aliasesLetterSpacingDefault
});
const generatePromoCaption = (tokens) => ({
    fontFamily: tokens.aliasesFontFamilyPromo,
    fontSize: tokens.aliasesPromoFontSizeCaption,
    lineHeight: '125%',
    letterSpacing: tokens.aliasesLetterSpacingDefault
});
const generateTypography = (tokens) => ({
    fontWeightBold: tokens.aliasesFontWeightEmphasis,
    fontWeightMedium: tokens.aliasesFontWeightNeutral,
    fontWeightRegular: tokens.aliasesFontWeightDefault,
    fontWeightLight: tokens.aliasesFontWeightDefault,
    fontSize: parseFloat(tokens.aliasesFontSizeDefault),
    h1: {
        color: tokens.aliasesColorTextStaticEmphasis,
        fontFamily: tokens.aliasesFontFamilyHeader,
        fontSize: tokens.aliasesFontSizeH1,
        fontWeight: tokens.aliasesFontWeightDefault,
        letterSpacing: tokens.aliasesLetterSpacingDefault,
        lineHeight: tokens.aliasesLineHeightH1
    },
    h2: {
        color: tokens.aliasesColorTextStaticEmphasis,
        fontFamily: tokens.aliasesFontFamilyHeader,
        fontSize: tokens.aliasesFontSizeH2,
        fontWeight: tokens.aliasesFontWeightDefault,
        letterSpacing: tokens.aliasesLetterSpacingDefault,
        lineHeight: tokens.aliasesLineHeightH2
    },
    h3: {
        color: tokens.aliasesColorTextStaticEmphasis,
        fontFamily: tokens.aliasesFontFamilyHeader,
        fontSize: tokens.aliasesFontSizeH3,
        fontWeight: tokens.aliasesFontWeightDefault,
        letterSpacing: tokens.aliasesLetterSpacingDefault,
        lineHeight: tokens.aliasesLineHeightH3
    },
    h4: {
        color: tokens.aliasesColorTextStaticEmphasis,
        fontFamily: tokens.aliasesFontFamilyDefault,
        fontSize: tokens.aliasesFontSizeH4,
        fontWeight: tokens.aliasesFontWeightDefault,
        letterSpacing: tokens.aliasesLetterSpacingDefault,
        lineHeight: tokens.aliasesLineHeightH4
    },
    caption: Object.assign(Object.assign({}, generateCaption(tokens)), { color: tokens.aliasesColorTextStaticEmphasis, fontWeight: tokens.aliasesFontWeightEmphasis }),
    captionNeutral: Object.assign(Object.assign({}, generateCaption(tokens)), { color: tokens.aliasesColorTextStaticSubtle, fontWeight: tokens.aliasesFontWeightNeutral }),
    body1: {
        color: tokens.aliasesColorTextStaticEmphasis,
        fontFamily: tokens.aliasesFontFamilyDefault,
        fontSize: tokens.aliasesFontSizeDefault,
        fontWeight: tokens.aliasesFontWeightDefault,
        lineHeight: tokens.aliasesLineHeightDefault,
        letterSpacing: tokens.aliasesLetterSpacingDefault
    },
    body1Bold: {
        color: tokens.aliasesColorTextStaticEmphasis,
        fontFamily: tokens.aliasesFontFamilyDefault,
        fontSize: tokens.aliasesFontSizeDefault,
        fontWeight: tokens.aliasesFontWeightEmphasis,
        lineHeight: tokens.aliasesLineHeightDefault,
        letterSpacing: tokens.aliasesLetterSpacingDefault
    },
    micro: {
        color: tokens.aliasesColorTextStaticEmphasis,
        fontFamily: tokens.aliasesFontFamilyDefault,
        fontSize: tokens.aliasesFontSizeMicro,
        fontWeight: tokens.aliasesFontWeightDefault,
        lineHeight: tokens.aliasesLineHeightMicro,
        letterSpacing: tokens.aliasesLetterSpacingDefault
    },
    promoH1: {
        color: tokens.aliasesColorTextStaticEmphasis,
        fontFamily: tokens.aliasesFontFamilyPromo,
        fontSize: tokens.aliasesPromoFontSizeH1,
        fontWeight: tokens.aliasesPromoFontWeightDefault,
        lineHeight: tokens.aliasesPromoLineHeightDefault,
        letterSpacing: tokens.aliasesLetterSpacingDefault
    },
    promoH2: {
        color: tokens.aliasesColorTextStaticEmphasis,
        fontFamily: tokens.aliasesFontFamilyPromo,
        fontSize: tokens.aliasesPromoFontSizeH2,
        fontWeight: tokens.aliasesPromoFontWeightDefault,
        lineHeight: tokens.aliasesPromoLineHeightDefault,
        letterSpacing: tokens.aliasesLetterSpacingDefault
    },
    promoH3: {
        color: tokens.aliasesColorTextStaticEmphasis,
        fontFamily: tokens.aliasesFontFamilyPromo,
        fontSize: tokens.aliasesPromoFontSizeH3,
        fontWeight: tokens.aliasesPromoFontWeightDefault,
        lineHeight: tokens.aliasesPromoLineHeightDefault,
        letterSpacing: tokens.aliasesLetterSpacingDefault
    },
    promoH4: {
        color: tokens.aliasesColorTextStaticEmphasis,
        fontFamily: tokens.aliasesFontFamilyPromo,
        fontSize: tokens.aliasesPromoFontSizeH4,
        fontWeight: tokens.aliasesPromoFontWeightDefault,
        lineHeight: tokens.aliasesPromoLineHeightDefault,
        letterSpacing: tokens.aliasesLetterSpacingDefault
    },
    promoBody1: {
        color: tokens.aliasesColorTextStaticEmphasis,
        fontFamily: tokens.aliasesFontFamilyPromo,
        fontSize: tokens.aliasesPromoFontSizeDefault,
        fontWeight: tokens.aliasesPromoFontWeightDefault,
        lineHeight: tokens.aliasesPromoLineHeightDefault,
        letterSpacing: tokens.aliasesLetterSpacingDefault
    },
    promoBody1Bold: {
        color: tokens.aliasesColorTextStaticEmphasis,
        fontFamily: tokens.aliasesFontFamilyPromo,
        fontSize: tokens.aliasesPromoFontSizeDefault,
        fontWeight: tokens.aliasesPromoFontWeightEmphasis,
        lineHeight: tokens.aliasesPromoLineHeightDefault,
        letterSpacing: tokens.aliasesLetterSpacingDefault
    },
    promoCaption: Object.assign(Object.assign({}, generatePromoCaption(tokens)), { color: tokens.aliasesColorTextStaticEmphasis, fontWeight: tokens.aliasesPromoFontWeightEmphasis }),
    promoCaptionNeutral: Object.assign(Object.assign({}, generatePromoCaption(tokens)), { color: tokens.aliasesColorTextStaticSubtle, fontWeight: tokens.aliasesPromoFontWeightNeutral }),
    promoMicro: {
        color: tokens.aliasesColorTextStaticEmphasis,
        fontFamily: tokens.aliasesFontFamilyPromo,
        fontSize: tokens.aliasesPromoFontSizeMicro,
        fontWeight: tokens.aliasesPromoFontWeightEmphasis,
        lineHeight: '125%',
        letterSpacing: tokens.aliasesLetterSpacingDefault
    }
});
export default generateTypography;
//# sourceMappingURL=typographyTokens.js.map